import { PureComponent } from 'preact-compat'

export interface TopicMetadataProps {
  publishedAt: string
  replyCount: number
  views: number
  votes?: number
  likes?: number
}

class TopicMetadata extends PureComponent<TopicMetadataProps> {
  render() {
    const { publishedAt, replyCount, views, votes, likes } = this.props
    return (
      <ul className='topic-moderation--topic-info__metadata'>
        <li className='topic-moderation--topic-info__metadata-item'>{publishedAt}</li>
        {votes !== undefined && (
          <li className='topic-moderation--topic-info__metadata-item'>Votes: {votes}</li>
        )}
        {likes !== undefined && (
          <li className='topic-moderation--topic-info__metadata-item'>Likes: {likes}</li>
        )}
        <li className='topic-moderation--topic-info__metadata-item'>Replies: {replyCount}</li>
        <li className='topic-moderation--topic-info__metadata-item'>Views: {views}</li>
      </ul>
    )
  }
}

export default TopicMetadata
